import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_STRETCH_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-personal-s1-chest-stretch",
    "name": "胸大肌静态拉伸",
    "group": "stretch",
    "subCategory": "chest-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-chest-stretch"
    ],
    "sourceId": "course-20261008-personal-01-01",
    "targetMuscles": [
      "胸大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-posterior-delt-stretch",
    "name": "三角肌后束静态拉伸",
    "group": "stretch",
    "subCategory": "shoulder-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-posterior-delt-stretch"
    ],
    "sourceId": "course-20261008-personal-01-02",
    "targetMuscles": [
      "三角肌后束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-anterior-delt-stretch",
    "name": "三角肌前束静态拉伸",
    "group": "stretch",
    "subCategory": "shoulder-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-anterior-delt-stretch"
    ],
    "sourceId": "course-20261008-personal-01-03",
    "targetMuscles": [
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-back-tricep-stretch",
    "name": "背部与三头静态拉伸",
    "group": "stretch",
    "subCategory": "arm-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-back-tricep-stretch"
    ],
    "sourceId": "course-20261008-personal-01-04",
    "targetMuscles": [
      "背阔肌",
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-rhomboid-stretch",
    "name": "菱形肌静态拉伸",
    "group": "stretch",
    "subCategory": "back-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-rhomboid-stretch"
    ],
    "sourceId": "course-20261008-personal-01-05",
    "targetMuscles": [
      "菱形肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-bicep-stretch",
    "name": "二头肌静态拉伸",
    "group": "stretch",
    "subCategory": "arm-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-bicep-stretch"
    ],
    "sourceId": "course-20261008-personal-01-06",
    "targetMuscles": [
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-abs-oblique-stretch",
    "name": "腹肌与腹斜肌静态拉伸",
    "group": "stretch",
    "subCategory": "abs-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-abs-oblique-stretch"
    ],
    "sourceId": "course-20261008-personal-01-07",
    "targetMuscles": [
      "腹直肌",
      "腹斜肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-glute-stretch",
    "name": "臀大肌静态拉伸",
    "group": "stretch",
    "subCategory": "leg-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-glute-stretch"
    ],
    "sourceId": "course-20261008-personal-01-08",
    "targetMuscles": [
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-hamstring-stretch",
    "name": "腘绳肌静态拉伸",
    "group": "stretch",
    "subCategory": "leg-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-hamstring-stretch"
    ],
    "sourceId": "course-20261008-personal-01-09",
    "targetMuscles": [
      "腘绳肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-quad-stretch",
    "name": "股四头肌静态拉伸",
    "group": "stretch",
    "subCategory": "leg-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-quad-stretch"
    ],
    "sourceId": "course-20261008-personal-01-10",
    "targetMuscles": [
      "股四头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-calf-stretch",
    "name": "小腿静态拉伸",
    "group": "stretch",
    "subCategory": "leg-stretch",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-calf-stretch"
    ],
    "sourceId": "course-20261008-personal-01-11",
    "targetMuscles": [
      "腓肠肌",
      "比目鱼肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s1-levator-scap-stretch",
    "name": "肩胛提肌静态拉伸",
    "group": "stretch",
    "subCategory": "neck",
    "equipment": "bodyweight",
    "pattern": "静态拉伸",
    "legacyIds": [
      "personal-s1-levator-scap-stretch"
    ],
    "sourceId": "course-20261008-personal-01-12",
    "targetMuscles": [
      "肩胛提肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
